import { Form, Card, Typography, Row, Col, Input, Avatar, Radio } from 'antd';
import { getAll as getIDTypes } from '../../../api/module/identification_types';

import { IsRole, validatorNumbers } from '../../../utils/helpers/helpers';
import { SignatureOutlined } from '@ant-design/icons';
import { CustomSelector } from '../../../components';
import BetterUpload from '../../../components/BetterUpload';
import { useState } from 'react';

const { Title } = Typography;

const LegalPersonFormSignatureSection = ({ readOnly = false }) => {
  const [superUser] = useState(IsRole(6));
  return (
    <Card
      size={'small'}
      bordered={false}
      title={
        <Title level={3}>
          <Avatar
            size={32}
            icon={<SignatureOutlined />}
            style={{ backgroundColor: '#20b2aa', color: 'white' }}
            shape="square"
          />{' '}
          Firma documentos contractuales
        </Title>
      }
    >
      <Form.Item
        name="es_firma_representante_legal"
        label="¿Los documentos contractuales los firma el representante legal?"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group disabled={readOnly}>
          <Radio value={true}>Si</Radio>
          <Radio value={false}>No</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item noStyle dependencies={['es_firma_representante_legal']}>
        {({ getFieldValue }) =>
          getFieldValue('es_firma_representante_legal') === false ? (
            <Row gutter={12}>
              <Col span={12}>
                <Form.Item
                  name="nombres_firmante"
                  label="Nombre(s) del firmante"
                  rules={[
                    {
                      required: true,
                      message: 'Nombre(s) del firmante es requerido',
                    },
                  ]}
                >
                  <Input
                    allowClear
                    placeholder="Nombre(s) del firmante..."
                    disabled={readOnly}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="apellidos_firmante"
                  label="Apellido(s) del firmante"
                  rules={[
                    {
                      required: true,
                      message: 'Apellido(s) del firmante es requerido',
                    },
                  ]}
                >
                  <Input
                    allowClear
                    placeholder="Apellido(s) del firmante..."
                    disabled={readOnly}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="tipo_identificacion_firmante"
                  label="Tipo de documento del firmante"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                  valuePropName="initialValue"
                >
                  <CustomSelector
                    endpointFetch={getIDTypes}
                    valueName="id"
                    labelName="nombre"
                    disabled={readOnly}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="numero_identificacion_firmante"
                  label="Número de documento del firmante"
                  rules={[
                    {
                      required: true,
                    },
                    validatorNumbers(6),
                  ]}
                >
                  <Input
                    style={{ width: '100%' }}
                    placeholder="Número de documento del firmante"
                    disabled={readOnly}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="cargo_firmante"
                  label="Cargo del firmante"
                  rules={[
                    {
                      required: true,
                      message: 'Cargo del firmante es requerido',
                    },
                  ]}
                >
                  <Input
                    allowClear
                    placeholder="Cargo del firmante..."
                    disabled={readOnly}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="numero_celular_firmante"
                  label="Teléfono de notificación del firmante"
                  rules={[
                    {
                      required: true,
                    },
                    validatorNumbers(7, true),
                  ]}
                >
                  <Input
                    placeholder="Teléfono del firmante..."
                    disabled={readOnly}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={24}>
                <Form.Item
                  name="firmante_autorizado"
                  label="¿Esta persona está autorizada para firmar documentos en el certificado de existencia de represantación legal?"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Radio.Group disabled={readOnly}>
                    <Radio value={true}>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Form.Item dependencies={['firmante_autorizado']}>
                {({ getFieldValue }) =>
                  getFieldValue('firmante_autorizado') === false ? (
                    <Col span={24}>
                      <Form.Item
                        name="firmante_documento_autorizante"
                        label="Por favor, cargue el documento que lo faculta para la firma de documentos"
                        rules={[
                          {
                            required: true,
                            message: 'El documento es requerido',
                          },
                        ]}
                      >
                        <BetterUpload fileType="pdf" />
                      </Form.Item>
                    </Col>
                  ) : null
                }
              </Form.Item> */}
            </Row>
          ) : null
        }
      </Form.Item>
    </Card>
  );
};

export default LegalPersonFormSignatureSection;
